import React, { useRef } from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCTA } from "./components/FloatingCTA";
import { PurchasePopup } from "./components/PurchasePopup";
import { Hero } from "./components/sections/Hero";
import { ProblemSection } from "./components/sections/ProblemSection";
import { BeforeAfter } from "./components/sections/BeforeAfter";
import { Situations } from "./components/sections/Situations";
import { Volumes } from "./components/sections/Volumes";
import { Bonuses } from "./components/sections/Bonuses";
import { Offer } from "./components/sections/Offer";
import { Guarantee } from "./components/sections/Guarantee";
import { Testimonials } from "./components/sections/Testimonials";
import { About } from "./components/sections/About";
import { FAQ } from "./components/sections/FAQ";
import { FinalCTA } from "./components/sections/FinalCTA";
import { Footer } from "./components/sections/Footer";
export function App() {
  const heroCtaRef = useRef<HTMLDivElement>(null);
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-ink antialiased" data-id="element-0" data-mp="3ij61k21ff746">
      <MetaPixel data-id="element-1" data-mp="3mjzsl4a6121a" />
      <Hero ctaRef={heroCtaRef} data-id="element-2" data-mp="3mjg9hk8s47lo" />
      <main data-id="element-3" data-mp="3rcj8i7wbs999">
        <ProblemSection data-id="element-4" data-mp="3rbzmog3k10py" />
        <BeforeAfter data-id="element-5" data-mp="3rdkl4gszp3t3" />
        <Situations data-id="element-6" data-mp="3recdzjv7cnfo" />
        <Volumes data-id="element-7" data-mp="5yi8qe3h5da" />
        <Bonuses data-id="element-8" data-mp="6hovayao7c0" />
        <Offer data-id="element-9" data-mp="4wx1t3d72hu" />
        <Guarantee data-id="element-10" data-mp="5gfdawxfswe" />
        <Testimonials data-id="element-11" data-mp="82jt1oitsae" />
        <About data-id="element-12" data-mp="2zld1d7i6tbah" />
        <FAQ data-id="element-13" data-mp="2zlli5ahfl0qy" />
        <FinalCTA data-id="element-14" data-mp="2zm4wkh7vh708" />
      </main>
      <Footer data-id="element-15" data-mp="2zmwh8wzxlkbq" />
      <FloatingCTA anchorRef={heroCtaRef} data-id="element-16" data-mp="2zng32ospcsv1" />
      <PurchasePopup data-id="element-17" data-mp="33lx18iu5at0b" />
    </div>;
}